module.exports = __webpack_public_path__ + "img/meeting_2.a083584a.jpg";